import axios from 'axios'

export const getTutorials = () => {
  return axios.get('/tutorial/tutorial')
}

export const setGuideCompleted = (id: string) => {
  return axios.post(`/tutorial/tutorial/${id}`)
}

export const deleteGuide = (id: string) => {
  return axios.delete(`tutorial/tutorial/${id}`)
}
